(function () {
  function encode(value) {
    return encodeURIComponent(value || "");
  }

  function readStoredReturnTo() {
    try {
      var fromUrl = new URLSearchParams(window.location.search).get("unonight_return");
      if (fromUrl) {
        sessionStorage.setItem("unonight_wishlist_return_to", fromUrl);
        return fromUrl;
      }
      var stored = sessionStorage.getItem("unonight_wishlist_return_to");
      if (stored) return stored;
    } catch (_error) {}
    return null;
  }

  function buildWishlistHref(link, variant) {
    if (!link || !variant) return null;

    var platformUrl = link.dataset.platformUrl || "https://unonight.com";
    var productPath = link.dataset.productUrl || window.location.pathname;
    var productPageUrl = window.location.origin + productPath;
    var storedReturn = readStoredReturnTo();
    // shop_url must always be the Shopify product page — never the platform return path.
    var shopUrl = productPageUrl;
    // return_to may be platform /profile/wishlist (from unonight_return) or the product page.
    var returnTo = storedReturn || productPageUrl;
    var imageUrl = link.dataset.imageUrl || "";
    var title = link.dataset.productTitle || "";
    var productId = link.dataset.productId || "";

    var params = new URLSearchParams();
    params.set("variant_id", String(variant.id));
    params.set("title", title);
    if (imageUrl) params.set("image_url", imageUrl);
    if (variant.price) {
      params.set("price_display", variant.price.amount + " " + (variant.price.currencyCode || "NOK"));
    }
    if (productId) params.set("product_id", productId);
    params.set("shop_url", shopUrl);
    params.set("return_to", returnTo);

    return platformUrl.replace(/\/$/, "") + "/wishlist/add?" + params.toString();
  }

  function tierFromVariantPrice(price) {
    var amount = Number(price);
    if (!Number.isFinite(amount)) return "silver";
    if (amount >= 500000 || amount === 5000) return "elite_diamond";
    if (amount >= 250000 || amount === 2500) return "gold";
    return "silver";
  }

  function syncMembershipUpgradeLink(root) {
    var link = root.querySelector("[data-unonight-membership-upgrade]");
    if (!link) return;

    var form = root.closest("product-form") || root.querySelector("product-form");
    var variantInput = form ? form.querySelector(".product-variant-id, input[name='id']") : null;
    if (!variantInput || !variantInput.value) return;

    var variantId = variantInput.value;
    var productJson = root.querySelector("[data-product-json]");
    var variant = null;

    if (productJson) {
      try {
        var product = JSON.parse(productJson.textContent);
        variant = (product.variants || []).find(function (item) {
          return String(item.id) === String(variantId);
        });
      } catch (_error) {
        variant = null;
      }
    }

    var tier = link.dataset.membershipTier || "silver";
    if (variant && variant.price != null) {
      tier = tierFromVariantPrice(variant.price);
    }

    var platformUrl = (link.dataset.platformUrl || "https://unonight.com").replace(/\/$/, "");
    var returnTo = link.dataset.returnTo || "";
    var params = new URLSearchParams();
    params.set("plan", tier);
    if (returnTo) params.set("return_to", returnTo);
    link.setAttribute("href", platformUrl + "/membership/upgrade?" + params.toString());
    link.dataset.membershipTier = tier;
  }

  function syncWishlistLink(root) {
    var link = root.querySelector("[data-unonight-wishlist]");
    if (!link) return;

    var form = root.closest("product-form") || root.querySelector("product-form");
    var variantInput = form ? form.querySelector(".product-variant-id, input[name='id']") : null;
    if (!variantInput || !variantInput.value) return;

    var variantId = variantInput.value;
    var productJson = root.querySelector("[data-product-json]");
    var variant = null;

    if (productJson) {
      try {
        var product = JSON.parse(productJson.textContent);
        variant = (product.variants || []).find(function (item) {
          return String(item.id) === String(variantId);
        });
      } catch (_error) {
        variant = null;
      }
    }

    if (!variant) {
      variant = { id: variantId };
    }

    var href = buildWishlistHref(link, variant);
    if (href) link.setAttribute("href", href);
  }

  function init() {
    document.querySelectorAll(".product-form, product-form").forEach(function (form) {
      var root = form.closest(".product") || form.parentElement || document.body;
      syncWishlistLink(root);
      syncMembershipUpgradeLink(root);
      form.addEventListener("change", function () {
        syncWishlistLink(root);
        syncMembershipUpgradeLink(root);
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", init);
})();
